import { render } from "./JourneyCampaign.vue?vue&type=template&id=137236c6"
import script from "./JourneyCampaign.vue?vue&type=script&lang=js"
export * from "./JourneyCampaign.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__